var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 7.5,
    transform: "matrix(-1 0 0 1 27 0)",
    fill: "#161A23"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 7.5,
    transform: "matrix(-1 0 0 1 27 0)",
    stroke: "#2D2F39"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4708 17.5284C16.7311 17.7888 16.7311 18.2109 16.4708 18.4712C16.2104 18.7316 15.7883 18.7316 15.5279 18.4712L11.5279 14.4712C11.2676 14.2109 11.2676 13.7888 11.5279 13.5284L15.5279 9.52843C15.7883 9.26808 16.2104 9.26808 16.4708 9.52843C16.7311 9.78878 16.7311 10.2109 16.4708 10.4712L12.9422 13.9998L16.4708 17.5284Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarOpen);
export default __webpack_public_path__ + "static/media/sidebar-open.31c89b984fd7c02ec9f81668ff54fb07.svg";
export { ForwardRef as ReactComponent };